import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useBanner } from '../../../commons/customHooks/Banner';
import { useCharacter, useCharacterFavorite } from '../../../commons/customHooks/Character';
import { useCoupon, usePoint } from '../../../commons/customHooks/GiftBox';
import { useRestrictedKeywords, useVideoTemplate } from '../../../commons/customHooks/Video';
import { resetCharacters } from '../../Character/redux/actions';
import VideoMessageMakerStepComponent from '../components/messageMakerStep';
import * as videoAction from '../redux/actions';

const VideoMessageMakerStepContainer = () => {
  const [bannerParams] = useState({
    type: 'app_video_maker'
  })
  const [ banners ] = useBanner(bannerParams);
  const [ coupon ] = useCoupon();
  const [params, setParams] = useState({
    per_page: 0
  })

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetCharacters())
  }, [])
  const [paramRestricted, setParamRestricted] = useState({
    page_size: 0
  })

  const [paramsCharacter, setParamsCharacter] = useState({
    relation: 'models'
  })
  const [ videoTemplate ] = useVideoTemplate(params);
  const [ restrictedKeyword ] = useRestrictedKeywords(paramRestricted);
  
  const [ character ] = useCharacter(paramsCharacter);

  const [ point ] = usePoint();
  return <VideoMessageMakerStepComponent 
    pushDataVideoStepOne={videoAction.pushDataVideoStepOne}
    pushDataVideoStepTwo={videoAction.pushDataVideoStepTwo}
    pushDataVideoStepThree={videoAction.pushDataVideoStepThree}
    pushDataVideoStepFour={videoAction.pushDataVideoStepFour}
    videoPaymentSaveRequest={videoAction.videoPaymentSaveRequest}
    videoPaymentClearState={videoAction.videoPaymentClearState}
    characters={[]}
    banners={banners}
    coupon={coupon}
    videoTemplate={videoTemplate}
    character={character}
    point={point}
    restrictedKeyword={restrictedKeyword}
  />;
};

export default VideoMessageMakerStepContainer;
